import { z } from 'zod'

export const reorderBrokerAccountsSchema = z.object({
  ids: z.array(z.string().guid()).min(1),
})

export type ReorderBrokerAccountsDto = z.infer<typeof reorderBrokerAccountsSchema>
